import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class ChecklistService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/checklists`);
  }

  listGlobalChecklists(): Observable<{ name: string; text: string }[]> {
    return this.http.get<{ name: string; text: string }[]>(`${environment.apiBaseUrl}/checklists/global_checklists`);
  }
}
